import React, { Component } from 'react';
import Datas from '../../data/client/clients.json';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/client.js';
import { withTranslation } from 'react-i18next';

class Clients extends Component {
    render() {
        const { t } = this.props;
        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper event-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Clients Area */}
                    <section className="event-page-area">
                        <Container>
                            <h4 className="tab-title mb-4">{t('clients_page.title')}</h4>
                            <Row>
                                {Datas.map((data, i) => (
                                    <Col xl="3" lg="4" md="6" sm="12" key={i} className="mb-4">
                                        <div className="event-box">
                                            <div className="event-img">
                                                <Link to={process.env.PUBLIC_URL + data.eventLink}>
                                                    <img
                                                        src={process.env.PUBLIC_URL + `/assets/images/${data.eventImg}`}
                                                        alt=""
                                                        className="img-fluid"
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Container>
                    </section>

                    {/* Footer 2 */}
                    <FooterTwo />

                </div>
            </Styles>
        );
    }
}

export default withTranslation()(Clients);